document.addEventListener("DOMContentLoaded", () => {
    const pricingExpands = document.querySelectorAll(".pricing-expand");

    pricingExpands.forEach((pricingExpand) => {
        pricingExpand.addEventListener("click", (e) => {
            const expandId = pricingExpand.dataset.expandId;

            var pricingExpandableContent = document.getElementById(expandId);
            pricingExpandableContent.classList.toggle("d-none");
        });
    });
});
